export const config = {};
export default {
    bind(el, bind, vm) {
        const options = {
            callback: vm.context.close
        };
        if (vm.context.show) {
            const tmpShow = vm.context.show;
            vm.context.show = function () {
                const result = tmpShow.apply(vm.context, arguments);
                config.handler.subscribe(options);
                return result;
            };
        }
        if (vm.context.close) {
            const tmpClose = vm.context.close;
            vm.context.close = () => {
                const result = tmpClose.apply(vm.context, arguments);
                config.handler.unsubscribe(options);
                return result;
            };
        }
    }
};
